<template>
  <div class="native-upload">
    <template v-if="loadingStatus === 0">
      <div class="uploader" @click="takePhoto">
        <div class="img-tips">
          <img :src="require('../../assets/image/settleAccount/photo.png')" alt="" />
        </div>
        <!--文本为：点击拍照-->
        <div class="desc">Click chụp hình</div>
      </div>
    </template>
    <!-- 上传状态 1上传中  2上传成功   3上传失败 -->
    <div class="mask" v-if="loadingStatus !== 0" @click="handleClickMask">
      <van-image class="pre-image" :src="preImg" />
      <!--文本为：上传中...-->
      <van-loading
        class="loading"
        type="spinner"
        v-if="loadingStatus === 1"
        size="24px"
        vertical
        >Đang tải lên…</van-loading>

      <div class="success" v-if="loadingStatus === 2">
        <span class="icon"><img :src="require('../../assets/image/settleAccount/gou3.png')" alt=""></span>
        <!--文本为：上传成功，点击查看-->
        <span class="desc_icon">Tải lên thành công, click vào kiểm tra</span>
      </div>
      <div class="failure" v-if="loadingStatus === 3">
        <span class="icon">!</span>
        <!--文本为：点击重新上传-->
        <span class="desc_icon">Click để tải lại</span>
      </div>
      <div class="close" v-if="loadingStatus !== 0" @click.stop="close">
        <span class="close-icon">x</span>
      </div>
    </div>
    <van-image-preview
      v-model="showImagePreview"
      :images="images"
    ></van-image-preview>

  </div>
</template>

<script>
export default {
  name: "nativeUpload",
  props: {
    maxCount: {
      type: Number,
      default: 1,
    },
    status: {
      type: Number,
      default: 0,
    },
    keyValue: {
      type: String,
      default: "",
    },
    staticImg:{
      type:String,
      default:''
    },
    id:{
      type:[Number, String],
      default:0
    },
    preImg:{
      type: String,
      default:''
    },
    sourceType:{
      type: Boolean,
      default:false
    },
  },
  data() {
    return {
      showImagePreview: false,
      images: []
    };
  },
  computed: {
    loadingStatus() {
      return this.status;
    },
  },
  methods: {
    takePhoto() {
      this.$emit("takePhoto", {key: this.keyValue, sourceType: this.sourceType});
    },
    handleClickMask(){
      // debugger
      if(this.loadingStatus === 2) {
        // 上传成功，查看预览图
        this.showImagePreview = true
        this.images = []
        this.images.push(this.preImg)
      }
      if(this.loadingStatus === 3) {
        // 上传失败，重新上传
        // debugger
        this.$emit('takePhoto',{key:this.keyValue},3)
      }
    },
    close(){
      const params = {
        key: this.keyValue,
        id:this.id,
        status:this.loadingStatus
      };
      this.$emit('delete',params)
    }
  },
};
</script>

<style lang="less" scoped>
.native-upload {
  width: 100%;
  background: #fff;
  .uploader {
    width: 150px;
    height: 150px;
    display: flex;
    flex-direction: column;
    background: #f2f2f2;
    align-items: center;
    justify-content: center;
    .img-tips {
      width: 48px;
      height: 35px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .desc {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 10px;
    }
  }
  .mask {
    width: 100%;
    background: #000;
    height: 150px;
    position: relative;
    .close{
      padding: 5px;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
      .close-icon{
        display: block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        background: #000;
        color: #fff;
        font-size: 13px;
        border-radius: 50%;
      }
    }
    .pre-image,.loading,.success,.failure {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 2;
    }
    .pre-image {
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0.5;
    }
    .success, .failure{
      font-size: 12px;
      color: #fff;
      font-size: 600;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--theme-color);
        line-height: 20px;
        text-align: center;
        padding: 4px;
        margin-bottom: 5px;
        img {
          width: 100%;
          height: auto;
          margin-top: 1px;
          display: block;
        }
      }
      .desc_icon {
        display: block;
        width: 150px;
        text-align: center;
      }
    }
    .failure {
      .icon {
        background: #ff6248;
        padding:0 5px ;
      }
    }
  }
}
</style>
